<template>
  <div class="">
    <filter-button
      class="district-button"
      :active="buttonActive"
      @click.native="openFilter"
    >
      {{ districtName }}
      <dropdown-symbol :active="modalActive"/>
    </filter-button>

    <filter-modal modal-key="district" :active="modalActive" @close="closeFilter">
      <district-filter
        :selected-ics="selectedIcs"
        :selected-districts="selectedDistricts"
        @changeDistrict="$emit('changeDistrict', $event)"
      />
    </filter-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import FilterButton from '@/components/Stock/Filters/Button';
import FilterModal from '@/components/Stock/Filters/Modal';
import DistrictFilter from '@/components/Stock/Filters/DistrictFilter';
import DropdownSymbol from '@/components/DropdownSymbol';

export default {
  props: [
    'selectedIcs',
    'selectedDistricts',
  ],
  components: {
    FilterButton,
    FilterModal,
    DistrictFilter,
    DropdownSymbol
  },
  data() {
    return {
      modalKey: 'district',
      modalActive: false,
    };
  },
  methods: {
    ...mapActions([
      'toggleModal',
    ]),
    openFilter() {
      this.$emit('open');
      this.modalActive = true;
    },
    closeFilter() {
      this.$emit('close');
      this.modalActive = false;
    },
  },
  computed: {
    buttonActive() {
      return this.selectedDistricts.length > 0;
    },
    districtName() {
      if (Array.isArray(this.selectedDistricts) && this.selectedDistricts.length > 0) {
        return this.$i18n.locale === 'en' ?
          `${this.selectedDistricts.length} district(s) selected` :
          `已選 ${this.selectedDistricts.length} 個地區`;
      }
      return this.$t('find.ALL_DISTRICT');
    },
  },
};
</script>

<style scoped>
.pin-icon {
  height: 17px;
  margin-bottom: 1px;
}

.district-wrapper {
  width: 450px;
  max-width: 85vw;
  margin: -14px -14px 0 -14px;
}

.district-wrapper >>> .region-container {
  padding-left: 14px;
  padding-right: 14px;
}

.district-button{
  border: 0;
  font-size: 16px;
}

.district-button:hover{
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
}

</style>
